module.exports = __webpack_public_path__ + "hostelworld-logo.png?f4d508449722c0b5c470df55fcc90a31";